var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-board" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading",
            },
          ],
          staticClass: "minimap-container",
          class: { "minimap-collapsed": _vm.minimapCollapsed },
        },
        [
          _c(
            "div",
            { staticClass: "minimap-toggle", on: { click: _vm.toggleMinimap } },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(
                  _vm._s(_vm.minimapCollapsed ? "unfold_more" : "unfold_less")
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.minimapCollapsed,
                  expression: "!minimapCollapsed",
                },
              ],
              staticClass: "minimap-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "minimap-slider",
                  style: {
                    left: _vm.scrollBarPosition + "px",
                    width: _vm.scrollBarWidth + "px",
                  },
                  on: { mousedown: _vm.startDragging },
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("visibility"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "minimap-scroll" },
                _vm._l(_vm.filteredPipelines, function (pipeline) {
                  return _c(
                    "a-tooltip",
                    {
                      key: pipeline._id,
                      attrs: {
                        placement: "top",
                        title: pipeline.name,
                        color: pipeline.color || "#1890ff",
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "minimap-item",
                        style: { backgroundColor: pipeline.color || "#1890ff" },
                        on: {
                          click: function ($event) {
                            return _vm.scrollToPipeline(pipeline._id)
                          },
                        },
                      }),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading",
            },
          ],
          key: _vm.workflowId + "_" + _vm.renderKey,
          staticClass: "supsis-draggable",
          attrs: {
            options: _vm.taskGroupDragOptions,
            draggable: ".drag-pipeline-columns",
          },
          on: { start: _vm.handleDragStart, end: _vm.movePipelineEnd },
          model: {
            value: _vm.pipelines,
            callback: function ($$v) {
              _vm.pipelines = $$v
            },
            expression: "pipelines",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "drag-container", attrs: { tag: "div" } },
            _vm._l(_vm.filteredPipelines, function (pipeline) {
              return _c("TaskColumnCard", {
                key: pipeline._id,
                ref: "pipeline_" + pipeline._id,
                refInFor: true,
                attrs: {
                  pipelineLoaded: _vm.pipelineLoaded,
                  pipelines: _vm.pipelines,
                  pipeline: pipeline,
                  moving: _vm.moving,
                  workflowId: _vm.workflowId,
                  tasks: _vm.tasks[pipeline._id],
                  checkedItems: _vm.checkedItems,
                  basicTaskForm: _vm.basicTaskForm,
                },
                on: {
                  loadMoreTask: _vm.loadMoreTask,
                  updateCheckedItems: function ($event) {
                    return _vm.$emit("updateCheckedItems", $event)
                  },
                  createdTask: function ($event) {
                    return _vm.createdTask(pipeline._id, $event)
                  },
                  updateBasicTaskForm: function ($event) {
                    return _vm.$emit("updateBasicTaskForm", $event)
                  },
                  resetActions: _vm.resetActions,
                  "close-create-mode": _vm.closeCreateMode,
                  moved: _vm.moveActionEnd,
                  "pipeline-form": _vm.createPipelineForm,
                  "create-pipeline": _vm.createPipeline,
                  "update-pipeline": _vm.updatePipeline,
                  "pipeline-deleted": _vm.handlePipelineDeleted,
                  "delete-modal-task": _vm.openDeleteTaskModal,
                  "confirm-modal-task": _vm.confirmModalOpen,
                  "archived-modal-task": _vm.archivedModalOpen,
                  "change-workflow-task": _vm.changeWorkflowTask,
                  "to-completed-task": _vm.toCompletedTask,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.deleteTaskModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteTaskCont"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteTaskModal = false
              },
              confirm: _vm.softDeleteTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmTaskModal
        ? _c("ConfirmModal", {
            attrs: {
              description: _vm.$t("task.sureAddCompletedList"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.confirmTaskModal = false
              },
              confirm: _vm.confirmTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("task.taskCloseModalTitle"),
            closable: true,
            maskClosable: true,
            okText: _vm.$t("task.batchConfirm"),
            cancelText: _vm.$t("message.cancel"),
            okButtonProps: {
              type: "primary",
              style: { backgroundColor: "#ec4b1d", borderColor: "#ec4b1d" },
            },
          },
          on: {
            ok: _vm.simpleDoneTask,
            cancel: function ($event) {
              _vm.simpleConfirmModal = false
            },
          },
          model: {
            value: _vm.simpleConfirmModal,
            callback: function ($$v) {
              _vm.simpleConfirmModal = $$v
            },
            expression: "simpleConfirmModal",
          },
        },
        [
          _c("div", { staticClass: "simple-confirm-modal-content" }, [
            _c("div", { staticClass: "modal-icon" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("check_circle"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-message" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("task.taskCloseConfirmQuestion"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "modal-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("task.taskCloseConfirmDetail")) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.archivedTaskModal
        ? _c("TaskArchiveModal", {
            attrs: {
              description: "Görevi Arşivlemek İstediğinize Emin Misiniz?",
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.archivedTaskModal = false
              },
              confirm: _vm.archiveModalTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("task.taskChangeWorkflowModalTitle") },
          on: { ok: _vm.handleChangeWorkflow, cancel: _vm.handleCancel },
          model: {
            value: _vm.changeWorkflowModal,
            callback: function ($$v) {
              _vm.changeWorkflowModal = $$v
            },
            expression: "changeWorkflowModal",
          },
        },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: _vm.$t("task.taskSelectWorkflowPlaceholder"),
              },
              model: {
                value: _vm.selectedWorkflow,
                callback: function ($$v) {
                  _vm.selectedWorkflow = $$v
                },
                expression: "selectedWorkflow",
              },
            },
            _vm._l(_vm.workflows, function (workflow) {
              return _c(
                "a-select-option",
                { key: workflow._id, attrs: { value: workflow._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(workflow.title) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "loading-content" }, [
              _c("div", { staticClass: "kanban-loader" }, [
                _c(
                  "svg",
                  {
                    staticClass: "kanban-loader-svg",
                    attrs: {
                      viewBox: "0 0 240 150",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "kl-shimmer",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "0%",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: { offset: "0%", "stop-color": "#eef2f7" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              attrs: { offset: "50%", "stop-color": "#ffffff" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#eef2f7",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "filter",
                          {
                            attrs: {
                              id: "kl-shadow",
                              x: "-20%",
                              y: "-20%",
                              width: "140%",
                              height: "140%",
                            },
                          },
                          [
                            _c("feDropShadow", {
                              attrs: {
                                dx: "0",
                                dy: "2",
                                stdDeviation: "2",
                                "flood-color": "#ec4b1d",
                                "flood-opacity": "0.35",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("g", { staticClass: "kl-column kl-col-1" }, [
                      _c("rect", {
                        staticClass: "kl-col-bg",
                        attrs: {
                          x: "10",
                          y: "12",
                          width: "64",
                          height: "128",
                          rx: "8",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "18",
                          y: "22",
                          width: "30",
                          height: "5",
                          rx: "2.5",
                          fill: "#ec4b1d",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "64",
                          cy: "24",
                          r: "3",
                          fill: "#ec4b1d",
                          opacity: "0.7",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        staticClass: "kl-card",
                        attrs: {
                          x: "16",
                          y: "36",
                          width: "52",
                          height: "24",
                          rx: "5",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "22",
                          y: "42",
                          width: "28",
                          height: "3",
                          rx: "1.5",
                          fill: "#cbd5e1",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "22",
                          y: "49",
                          width: "18",
                          height: "2.5",
                          rx: "1.25",
                          fill: "#e2e8f0",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        staticClass: "kl-card",
                        attrs: {
                          x: "16",
                          y: "66",
                          width: "52",
                          height: "24",
                          rx: "5",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "22",
                          y: "72",
                          width: "34",
                          height: "3",
                          rx: "1.5",
                          fill: "#cbd5e1",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "22",
                          y: "79",
                          width: "20",
                          height: "2.5",
                          rx: "1.25",
                          fill: "#e2e8f0",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { staticClass: "kl-column kl-col-2" }, [
                      _c("rect", {
                        staticClass: "kl-col-bg",
                        attrs: {
                          x: "88",
                          y: "12",
                          width: "64",
                          height: "128",
                          rx: "8",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "96",
                          y: "22",
                          width: "30",
                          height: "5",
                          rx: "2.5",
                          fill: "#fb923c",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "142",
                          cy: "24",
                          r: "3",
                          fill: "#fb923c",
                          opacity: "0.7",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        staticClass: "kl-card",
                        attrs: {
                          x: "94",
                          y: "66",
                          width: "52",
                          height: "24",
                          rx: "5",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "100",
                          y: "72",
                          width: "30",
                          height: "3",
                          rx: "1.5",
                          fill: "#cbd5e1",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "100",
                          y: "79",
                          width: "22",
                          height: "2.5",
                          rx: "1.25",
                          fill: "#e2e8f0",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { staticClass: "kl-column kl-col-3" }, [
                      _c("rect", {
                        staticClass: "kl-col-bg",
                        attrs: {
                          x: "166",
                          y: "12",
                          width: "64",
                          height: "128",
                          rx: "8",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "174",
                          y: "22",
                          width: "30",
                          height: "5",
                          rx: "2.5",
                          fill: "#22c55e",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "220",
                          cy: "24",
                          r: "3",
                          fill: "#22c55e",
                          opacity: "0.7",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        staticClass: "kl-card",
                        attrs: {
                          x: "172",
                          y: "36",
                          width: "52",
                          height: "24",
                          rx: "5",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "178",
                          y: "42",
                          width: "26",
                          height: "3",
                          rx: "1.5",
                          fill: "#cbd5e1",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "178",
                          y: "49",
                          width: "18",
                          height: "2.5",
                          rx: "1.25",
                          fill: "#e2e8f0",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        staticClass: "kl-moving-card",
                        attrs: { filter: "url(#kl-shadow)" },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            width: "52",
                            height: "24",
                            rx: "5",
                            fill: "#ec4b1d",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "9", cy: "12", r: "3", fill: "#ffffff" },
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "7",
                            width: "28",
                            height: "3",
                            rx: "1.5",
                            fill: "#ffffff",
                            opacity: "0.95",
                          },
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "14",
                            width: "18",
                            height: "2.5",
                            rx: "1.25",
                            fill: "#ffffff",
                            opacity: "0.7",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "kl-flow-path",
                      attrs: {
                        d: "M 42 90 Q 80 90 120 66 Q 160 42 198 60",
                        fill: "none",
                        stroke: "#ec4b1d",
                        "stroke-width": "1",
                        "stroke-dasharray": "3 4",
                        opacity: "0.35",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "loading-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.loading")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "loading-subtext" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("task.taskKanbanLoadingSubtext")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-dots" }, [
      _c("span", { staticClass: "loading-dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "loading-dot" }),
      _vm._v(" "),
      _c("span", { staticClass: "loading-dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }